import { useEffect, useState } from "react";
import { trending, categoryFilters } from "@/mocks/chigua";

export default function Trending() {
  const [filter, setFilter] = useState("全部");
  const [query, setQuery] = useState("");

  useEffect(() => {
    const onSearch = (e: Event) => {
      const detail = (e as CustomEvent<string>).detail;
      if (detail) setQuery(detail);
    };
    window.addEventListener("chigua-search", onSearch);
    return () => window.removeEventListener("chigua-search", onSearch);
  }, []);

  const list = trending.filter((t) => {
    const inCat = filter === "全部" || t.category === filter;
    const kw = query.trim();
    const inQuery = !kw || t.title.includes(kw) || t.desc.includes(kw) || t.tag.includes(kw);
    return inCat && inQuery;
  });

  return (
    <section id="trending" className="w-full scroll-mt-20 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        {/* section head */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-5 mb-8">
          <div>
            <p className="flex items-center gap-2 text-sm font-medium text-primary-600 mb-2">
              <span className="inline-block h-px w-8 bg-primary-400"></span>TRENDING NOW
            </p>
            <h2 className="font-display text-2xl md:text-4xl font-bold text-foreground-950">
              今日热榜 · <span className="text-primary-600">情报速递</span>
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl">
              按讨论热度排序的热门事件一览，点击标签即可切换分类，快速锁定你感兴趣的那块瓜田。
            </p>
          </div>
        </div>

        {/* filter bar */}
        <div className="mb-6 flex flex-col lg:flex-row lg:items-center gap-3 lg:gap-4">
          <div className="flex items-center gap-1 overflow-x-auto no-scrollbar rounded-full border border-background-300 bg-background-50 px-1 py-1 lg:flex-1">
            {categoryFilters.map((c) => (
              <button
                key={c}
                onClick={() => setFilter(c)}
                className={
                  "whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors " +
                  (filter === c
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-700 hover:bg-background-200/70")
                }
              >
                {c}
              </button>
            ))}
          </div>
          <label className="relative block lg:w-64 shrink-0">
            <i className="ri-search-line absolute left-3.5 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
            <input
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="在热榜中筛选…"
              className="w-full rounded-full border border-background-300 bg-background-50 px-10 py-2.5 text-sm text-foreground-900 outline-none placeholder:text-foreground-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
            />
            {query && (
              <button
                onClick={() => setQuery("")}
                aria-label="清空搜索"
                className="absolute right-2.5 top-1/2 -translate-y-1/2 flex h-6 w-6 items-center justify-center text-foreground-400 hover:text-foreground-700"
              >
                <i className="ri-close-circle-fill text-base"></i>
              </button>
            )}
          </label>
        </div>

        {/* list */}
        {list.length === 0 ? (
          <div className="rounded-xl border border-dashed border-background-300 bg-background-100/60 px-6 py-14 text-center">
            <i className="ri-inbox-2-line text-4xl text-foreground-400"></i>
            <p className="mt-3 text-sm text-foreground-600">没找到匹配的瓜，换个关键词试试吧～</p>
          </div>
        ) : (
          <ul className="flex flex-col gap-3">
            {list.map((t) => (
              <li key={t.id}>
                <a
                  href="#topic"
                  className="group flex items-center gap-4 rounded-xl border border-background-200 bg-background-50 px-4 md:px-5 py-4 transition-colors hover:border-primary-300 hover:bg-background-100"
                >
                  <span
                    className={
                      "flex h-9 w-9 md:h-11 md:w-11 shrink-0 items-center justify-center rounded-lg font-display text-base md:text-xl font-bold " +
                      (t.rank <= 3
                        ? "bg-primary-500 text-background-50"
                        : "bg-background-200 text-foreground-700")
                    }
                  >
                    {t.rank}
                  </span>
                  <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-2 flex-wrap">
                      <h3 className="text-sm md:text-base font-semibold text-foreground-950 group-hover:text-primary-700 transition-colors">
                        {t.title}
                      </h3>
                      <span className="whitespace-nowrap rounded-full bg-accent-100 text-accent-800 px-2.5 py-0.5 text-[11px]">
                        {t.tag}
                      </span>
                    </div>
                    <p className="mt-1 hidden md:block text-sm text-foreground-500 line-clamp-1">
                      {t.desc}
                    </p>
                  </div>
                  <div className="hidden sm:flex flex-col items-end gap-1 shrink-0">
                    <span className="text-xs font-medium text-foreground-500">
                      <i className="ri-fire-fill text-primary-500 mr-1"></i>
                      {t.heat}
                    </span>
                    <span className="text-[11px] text-foreground-400">{t.updated}</span>
                  </div>
                  <i className="ri-arrow-right-s-line text-xl text-foreground-400 group-hover:text-primary-500 transition-colors shrink-0"></i>
                </a>
              </li>
            ))}
          </ul>
        )}
      </div>
    </section>
  );
}